export const exportedImageType = 'image/jpeg';

export const exportedImageQuality = 0.9;

// Outer margin (in px) of the drawings inside the image borders.
export const exportedImageMargin = 50;

export const exportedImageExtension = 'jpg';

export const exportImageTimeout = 10000;
